import React, { useState, useEffect } from 'react';
import {
  Page,
  Grid,
  Card,
  BlockStack,
  Box,
  Text,
  Button,
  Badge,
  Tabs,
  InlineStack
} from '@shopify/polaris';
import { useNavigate } from "react-router-dom";

export default function Plan() {
  // Add a state to track whether monthly or annual plans are selected
  const [planType, setPlanType] = useState('monthly');
  
  // Separate states for monthly and annual plan selections
  const [monthlyPlan, setMonthlyPlan] = useState(-1);
  const [annualPlan, setAnnualPlan] = useState(-1);

  // Initialize plan selection based on localStorage
  useEffect(() => {
    const savedPlan = localStorage.getItem("plans");
    if (savedPlan) {
      const planId = parseInt(savedPlan);
      if (planId > 3) {
        // Annual plan
        setPlanType('annual');
        setAnnualPlan(planId - 3);
      } else {
        // Monthly plan
        setPlanType('monthly');
        setMonthlyPlan(planId);
      }
    }
  }, []);

  const navigate = useNavigate();

  // Define both monthly and annual plans
  const monthlyPlans = [
    {
      title: "Free",
      price: "$0",
      billing: "Valid For 30 Days",
      features: [
        "✔ Manage 5 items",
        "✔ Sync upto 0 items",
        "✖ Inventory Sync",
        "✖ Price Sync",
        "✖ Real time Sync",
        "✖ Priority Customer Support",
      ],
      buttonText: "Activate Now!"
    },         
    {
      title: "BRONZE",
      price: "$19.99/mo",
      billing: "Billed at $199 per year",
      features: [
        "✔ Import 500 items/month",
        "✔ Sync upto 1500 items",
        "✔ Inventory Sync",
        "✔ Price Sync",
        "✖ Real time Sync",
        "✖ Priority Customer Support"
      ],
      buttonText: "Activate Now!"
    },
    {
      title: "SILVER",
      price: "$29.99/mo",
      billing: "Billed at $299 per year",
      features: [
        "✔ Import 2000 items/month",
        "✔ Sync upto 6000 items",
        "✔ Inventory Sync",
        "✔ Price Sync",
        "✔ Real time Sync",
        "✔ Priority Customer Support"
      ],
      buttonText: "Activate Now!"
    },
    {
      title: "GOLD",
      price: "$59.99/mo",
      billing: "Billed at $599 per year",
      features: [
        "✔ Import 5000 items/month",
        "✔ Sync upto 15000 items",
        "✔ Inventory Sync",
        "✔ Price Sync",
        "✔ Real time Sync",
        "✔ Priority Customer Support"
      ],
      buttonText: "Activate Now!"
    }
  ];

  const annualPlans = [
    {
      title: "Free",
      price: "$0",
      billing: "Valid For 30 Days", 
      features: [
        "✔ Import 5 items/month",
        "✔ Import 5 items/year",
        "✔ Sync upto 0 items",
        "✖ Inventory Sync",
        "✖ Price Sync",
        "✖ Real time Sync",
        "✖ Priority Customer Support"
      ],
      buttonText: "Activate Now!"
    },
    {
      title: "BRONZE Annual",
      price: "$199/year",
      features: [
        "✔ Import 500 items/month",
        "✔ Import 6000 items/year",
        "✔ Sync upto 1500 items",
        "✔ Inventory Sync",
        "✔ Price Sync",
        "✖ Real time Sync",
        "✖ Priority Customer Support"
      ],
      buttonText: "Activate Now!"
    },
    {
      title: "SILVER Annual",
      price: "$299/year",
      features: [
        "✔ Import 2000 items/month",
        "✔ Import 24000 items/year",
        "✔ Sync upto 6000 items",
        "✔ Inventory Sync",
        "✔ Price Sync",
        "✔ Real time Sync",
        "✔ Priority Customer Support"
      ],
      buttonText: "Activate Now!"
    },
    {
      title: "GOLD Annual",
      price: "$599/year",
      features: [
        "✔ Import 5000 items/month",
        "✔ Import 60000 items/year",
        "✔ Sync upto 15000 items",
        "✔ Inventory Sync",
        "✔ Price Sync",
        "✔ Real time Sync",
        "✔ Priority Customer Support"
      ],
      buttonText: "Activate Now!"
    }
  ];
  
  const plans = planType === 'monthly' ? monthlyPlans : annualPlans;
  // Get the current selected plan based on the active tab
  // Special case: if either monthly or annual plan is Free (index 0), show Free as selected on both tabs
  const currentSelectedPlan = (monthlyPlan === 0 || annualPlan === 0) ? 
    0 : // Show Free plan as selected on both tabs
    (planType === 'monthly' ? monthlyPlan : annualPlan);

  const handlePlanActive = async (planId) => {
    let plan = planId;
    // Fix: Use explicit comparison and make sure actualPlanId is calculated correctly
    const actualPlanId = planType === 'monthly' || planId == 0 ? plan : parseInt(plan) + 3;
    
    console.log("Original plan ID:", plan);
    console.log("Plan type:", planType);
    console.log("Calculated actual plan ID:", actualPlanId);
    
    const tempCode = localStorage.getItem("tempcode");
    if (!tempCode) {
      navigate(`${process.env.REACT_APP_BASE_URL}login`);
      return;
    } 
    if(actualPlanId == 1 || actualPlanId == 2 || actualPlanId == 3){
      const url = `https://cp2.infoshoreapps.com/upgrade2.php?key=${tempCode}&type=${actualPlanId}`;
      window.location.href = url;
    }else if (actualPlanId == 4 || actualPlanId == 5 || actualPlanId == 6){
      const url = `https://cp2.infoshoreapps.com/upgradeannual.php?key=${tempCode}&type=${actualPlanId}`
      window.location.href = url;
    }else{
      const url = `https://cp2.infoshoreapps.com/deleteplan.php?key=${tempCode}&type=${actualPlanId}`
      window.location.href = url;
    }
  
  };

  const handleTabChange = (selectedTabIndex) => {
    console.log("handleTabChange");
    
    const newPlanType = selectedTabIndex === 0 ? 'monthly' : 'annual';
    setPlanType(newPlanType);
    
    // Don't reset anything - just switch the tab
    // The selected plans are maintained separately for each tab
  };

  const handlePlanSelection = (planIndex) => {
    if (planType === 'monthly') {
      setMonthlyPlan(planIndex);
      // Update localStorage for monthly plans (0-3)
      //localStorage.setItem("plans", planIndex.toString());
    } else {
      setAnnualPlan(planIndex);
      // Update localStorage for annual plans (4-7, so add 3 to the index)
      //localStorage.setItem("plans", (planIndex + 3).toString());
    }
    handlePlanActive(planIndex);
  };

  return (
    <Page fullWidth>
      <BlockStack gap="400">
        {/* Tabs for switching between monthly and annual plans */}
        <BlockStack gap="400" align="center">
          <div style={{ textAlign: 'center', margin: '0 auto', width: '100%' }}>
            <Text variant="headingLg" as="h1">
              {planType === 'monthly' ? "Monthly Plans With Real time Inventory Sync" : "Yearly Plans With Real time Inventory Sync"}
            </Text>
          </div>
          
          <InlineStack gap="200" align="center">
            <Text variant="bodyMd">Billed Annually</Text>
            <div className="toggle-switch" style={{ position: 'relative', display: 'inline-block' }}>
              <input
                type="checkbox"
                checked={planType === 'monthly'}
                onChange={() => handleTabChange(planType === 'monthly' ? 1 : 0)}
                style={{
                  position: 'absolute',
                  opacity: 0,
                  width: 0,
                  height: 0
                }}
                id="plan-toggle"
              />
              <label
                htmlFor="plan-toggle"
                style={{
                  display: 'block',
                  width: '60px',
                  height: '30px',
                  background: planType === 'monthly' ? '#4ade80' : '#e5e7eb',
                  borderRadius: '30px',
                  position: 'relative',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
              >
                <span
                  style={{
                    position: 'absolute',
                    top: '2px',
                    left: planType === 'monthly' ? '32px' : '2px',
                    width: '26px',
                    height: '26px',
                    borderRadius: '50%',
                    background: 'white',
                    transition: 'left 0.2s',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                  }}
                ></span>
              </label>
            </div>
            <Text variant="bodyMd">Billed Monthly</Text>
          </InlineStack>
        </BlockStack>
        <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 4 }} gap="400">
          {plans.map((p, index) => {
            // Check if the current plan is active based on the current tab
            const isActive = currentSelectedPlan === index;
            const isGold = p.title.includes("GOLD");

            return (
              <Card
                key={index}
                padding="400"
                roundedAbove="sm"
                tone={isActive ? "success" : "primary"}
                border={isGold ? "base" : undefined}
                height="100%"
              >
                <BlockStack gap="300" align="center">
                  <Box width="100%">
                    <Text variant="headingLg" fontWeight="bold">
                      {isGold ? (
                        <Badge tone="attention">{p.title}</Badge>
                      ) : (
                        p.title
                      )}
                    </Text>
                    <Text variant="headingMd" fontWeight="bold" tone="success">
                      {p.price}
                    </Text>
                    <Text variant="bodySm" color="subdued">
                      {p.billing}
                    </Text>
                  </Box>

                  <BlockStack as="ul" gap="100" alignment="leading">
                    {p.features.map((f, i) => (
                      <Text as="li" key={i} variant="bodyMd">
                        {f}
                      </Text>
                    ))}
                  </BlockStack>

                  <Box width="100%" paddingBlockStart="300" >
                    {isActive ? (
                      <Button tone="success" fullWidth disabled>
                        Activated
                      </Button>
                    ) : (
                      <Button
                        fullWidth
                        variant="primary"
                        onClick={() => handlePlanSelection(index)}
                      >
                        {p.buttonText}
                      </Button>
                    )}
                  </Box>
                </BlockStack>
              </Card>
            );
          })}
        </Grid>
      </BlockStack>
    </Page>
  );
}